// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    blackButtonLink: {
        href: "#",
        target: "_self"
    },
    blackButtonText: "Get Started",
    crmBold1: "AI deal prioritization",
    crmBold2: "Connected communication",
    crmBold3: "Post-sales & account management",
    crmButtonText: "Learn more",
    crmLink: {
        href: "#",
        target: "_self"
    },
    crmPopupButtonText: "Get Started",
    crmPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/AI_deal_prioritization.avif",
        alt: ""
    },
    crmPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/Connected_communication.avif",
        alt: ""
    },
    crmPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/Post-sales_account_management.avif",
        alt: ""
    },
    crmText: "Automate full customer journeys with AI actions",
    crmText1: "Score deal health and close probability with monday CRM, so teams can focus on converting.",
    crmText2: "\"Centralize outreach, lead activity, and performance analytics, so nothing falls through the cracks.\" <br />",
    crmText3: "Monitor account health, communicate and engage <br /> with clients to nurture key relationships.",
    crmTitle: "Automate full customer journeys with AI actions",
    devBold1: "AI developer assistance",
    devBold2: "Multi-method execution <br />",
    devBold3: "Agile insights",
    devButtonText: "Learn more",
    devLink: {
        href: "#",
        target: "_self"
    },
    devPopupButtonText: "Get Started",
    devPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/AI_developer_assistant.avif",
        alt: ""
    },
    devPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/Sprint_management.avif",
        alt: ""
    },
    devPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/Agile_insights.avif",
        alt: ""
    },
    devText: "Ship quality software with AI-guided sprints",
    devText1: "Resolve bugs and incidents faster with AI-surfaced context on related code, tasks, and documentation.",
    devText2: "Run sprints with Scrum, Kanban, or hybrid methods to move faster without admin blocks.",
    devText3: "Get real-time metrics like cycle time and sprint <br /> velocity to ensure predictable delivery.",
    devTitle: "Ship quality software with AI-guided sprints",
    servBold1: "AI ticket triage",
    servBold2: "AI ticket resolutions",
    servBold3: "Customer portal",
    servButtonText: "Learn more",
    servLink: {
        href: "#",
        target: "_self"
    },
    servText: "Deliver standout service with AI ticket handling",
    servText1: "Automatically categorize, prioritize, and route tickets <br /> with AI to speed up resolution times.",
    servText2: "Resolve repetitive requests instantly with AI-powered auto-replies based on past cases.",
    servText3: "Launch a dynamic portal for users to submit requests, track tickets, and access self-serve resources.",
    servTitle: "Deliver standout service with AI ticket handling",
    subTitle: "Each product solves departmental needs, and together, they power seamless operations across your organization.",
    svcPopupButtonText: "Get Started",
    svcPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751872278/Generator_featured%20images/hp-2025/products/popup-assets/triage-v2.avif",
        alt: ""
    },
    svcPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751885866/Generator_featured%20images/hp-2025/products/popup-assets/AI_ticket_resolutions-v2.avif",
        alt: ""
    },
    svcPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751528122/Generator_featured%20images/hp-2025/products/Customer_portal.avif",
        alt: ""
    },
    tag1: "Sales",
    tag2: "Engineering",
    tag3: "IT",
    tag4: "Marketing",
    title: "Solve work challenges <br /> with AI-first products",
    whiteButtonLink: {
        href: "/sales/contact-us",
        target: "_self"
    },
    whitebuttonText: "Request a demo",
    wmBold1: "AI-powered risk identification",
    wmBold2: "Project and portfolio management",
    wmBold3: "Resource management",
    wmButtonText: "Learn more",
    wmLink: {
        href: "#",
        target: "_self"
    },
    wmPopupButtonText: "Get Started",
    wmPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751872278/Generator_featured%20images/hp-2025/products/popup-assets/ai-powered-risk-identification-v2.avif",
        alt: ""
    },
    wmPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751885711/Generator_featured%20images/hp-2025/products/popup-assets/Project_and_portfolio_management-v3-.avif",
        alt: ""
    },
    wmPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751538698/Generator_featured%20images/hp-2025/products/popup-assets/resource-managment-v4.avif",
        alt: ""
    },
    wmText: "Drive projects and processes forward with AI insights",
    wmText1: "Use AI to flag risks early to make informed decisions across your entire portfolio.",
    wmText2: "Gain visibility into risks and dependencies to ensure fast and precise project delivery.",
    wmText3: "Use AI to assign the right people to every project based on skills, availability, and real-time capacity.",
    wmTitle: "Drive projects and processes forward with AI insights"
};
